export default __webpack_public_path__ + "static/media/watermark_high_white.708413e0.png";